<template>
  <li>
    <h2 class="h3">Master Report</h2>
    <div class="row">
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group">
              <label class="control-label">Program</label>
              <multiselect
                @input="handleSelectProgramCallback"
                :value="programSelected"
                :options="programs"
                track-by="id"
                label="name"
                v-validate="'required'"
                name="program"
                data-vv-validate-on="input|blur"
                :allow-empty="false"
                :searchable="true"
                :show-labels="false"
                :class="[errorClass('program'), validClass('program')]"
                placeholder/>

              <help-block field="program"/>
            </div>
          </div>

        </div><!-- /.row -->
      </div>

      <div class="col-lg-4 text-right">
        <ladda-button :click="handleGenerateReport" :validate="true" class="btn btn-info mt-lg-label">
          <font-awesome :icon="['far', 'file-spreadsheet']"/> Download CSV
        </ladda-button>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { programComputed, agencyComputed, agencyMethods } from 'vx/helpers'
import { map } from 'lodash'
import { http } from 'utils'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  data () {
    return {
      params: {
        program_id: null,
        placements: null,
        agencies: null
      },
      programSelected: null
    }
  },

  computed: {
    ...programComputed,
    ...agencyComputed,

    placementOptions () {
      let options = this.programSelected ? this.programSelected.placements : []

      return options
    }
  },

  async created () {
    await this.getAgencies()
  },

  methods: {
    ...agencyMethods,

    handleSelectProgramCallback (program) {
      this.programSelected = program

      this.params.program_id = program
        ? program.id
        : null

      this.params.placemens = null
    },

    async handleGenerateReport () {
      let params = {
        program_id: this.params.program_id,
        placement_ids: map(this.params.placements, 'id'),
        agency_ids: map(this.params.agencies, 'id')
      }

      return http.get(`reports/master-report`, { responseType: 'blob', params }).then(response => {
        let now = moment().format('DD-MM-YYYY-HH-mm')

        let filename = `master-report-${now}.csv`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, filename)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
    }
  }
}
</script>
